import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterX = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { xmlns: "http://www.w3.org/2000/svg", d: "M15.4201 16.192H13.8481L12.0001 13.156L10.1521 16.192H8.58008L11.2201 11.872L8.73608 7.79199H10.2961L12.0001 10.588L13.7041 7.79199H15.2761L12.7921 11.872L15.4201 16.192Z" }),
});

export { IconCapitalLetterX };
